import { all, takeLatest } from 'redux-saga/effects'

import { getCountriesSaga } from './sagas/get-countries.saga'
import { actionTypes } from './actions'

export function* countriesWatchSaga() {
  yield all([takeLatest(actionTypes.FETCH_COUNTRIES, getCountriesSaga)])
}
